import { mergeClassName } from '@chain-zen/ui'
import type { ReactNode } from 'react'
import { FileIcon } from 'react-file-utils'

interface DocumentPreviewShellProps {
  bodyClassName?: string
  children?: ReactNode
  footerLabel?: string
  href: string
  mimeType: string
  title: string
}

const DOCUMENT_PREVIEW_SHELL_CLASS =
  'w-[232px] max-w-full overflow-hidden rounded-md bg-white ring-1 ring-gray-200 dark:bg-background dark:ring-border'

export const DocumentPreviewShell = ({
  href,
  mimeType,
  title,
  children,
  bodyClassName,
  footerLabel = 'Download file to view it'
}: DocumentPreviewShellProps) => {
  return (
    <div data-testid="pdf-preview-shell" className={DOCUMENT_PREVIEW_SHELL_CLASS}>
      <div className="flex items-center gap-1 border-b border-gray-200/80 px-3 py-3 dark:border-border">
        <FileIcon filename={title} mimeType={mimeType} size={16} />
        <span className="truncate text-sm font-medium text-gray-900 dark:text-white">{title}</span>
      </div>

      {!!children && <div className={mergeClassName('p-3', bodyClassName)}>{children}</div>}

      <div className="border-t border-gray-200/80 px-3 py-3 dark:border-border">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={true}
          className="text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          {footerLabel}
        </a>
      </div>
    </div>
  )
}

export { DOCUMENT_PREVIEW_SHELL_CLASS }
